<div class="table-tr mb-16">
  <div appTableRow>
    <div appTableRowContent class="flex justify-between items-center">
      <span class="fw-700">{{endpoint.name}}</span>

      <div class="flex items-center mr-16" *ngIf="endpoint.url">
        <span *ngIf="showCopyUrl" (click)="onCopiedUrl()" [cdkCopyToClipboard]="endpoint.url"
          class="copy-url mat-body fw-500 copy-bottom">{{'VIEW_ENDPOINTS.COPY_URL' | transloco}}</span>
        <button class="white rounded" (click)="urlService.openUrlInNewTab(endpoint.url)">
          <div class="flex items-center">
            <mat-icon svgIcon="open_in_new" class="icon-sm mr-12"></mat-icon>
            <span class="button-text">{{'VIEW_ENDPOINTS.OPEN' | transloco}}</span>
          </div>
        </button>
      </div>

      <div class="flex items-center mr-16" *ngIf="!endpoint.url">
        <div class="flex items-center">
          <mat-icon svgIcon="info" class="icon-sm mr-12 fw-600 not-configure"></mat-icon>
          <span class="fw-600 define-typography-level not-configure">{{'VIEW_ENDPOINTS.NOT_CONFIGURED' |
            transloco}}</span>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="table-tr mb-16">
  <div appTableRow>
    <div appTableRowContent class="flex justify-between items-center">
      <span class="fw-700">{{gitlabendpoint.name}}</span>

      <div class="flex items-center mr-16" *ngIf="gitlabendpoint.url">
        <span *ngIf="showCopyUrl" (click)="onCopiedUrl()" [cdkCopyToClipboard]="gitlabendpoint.url"
          class="copy-url mat-body fw-500 copy-bottom">{{'VIEW_ENDPOINTS.COPY_URL' | transloco}}</span>
        <button class="white rounded" (click)="urlService.openUrlInNewTab(gitlabendpoint.url)">
          <div class="flex items-center">
            <mat-icon svgIcon="open_in_new" class="icon-sm mr-12"></mat-icon>
            <span class="button-text">{{'VIEW_ENDPOINTS.OPEN' | transloco}}</span>
          </div>
        </button>
      </div>

      <div class="flex items-center mr-16" *ngIf="!gitlabendpoint.url">
        <div class="flex items-center">
          <mat-icon svgIcon="info" class="icon-sm mr-12 fw-600 not-configure"></mat-icon>
          <span class="fw-600 define-typography-level not-configure">{{'VIEW_ENDPOINTS.NOT_CONFIGURED' |
            transloco}}</span>
        </div>
      </div>

    </div>
  </div>
</div>